import { Box, Typography } from "@mui/material";
import "./_style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { httpAPI_APP016, httpAPI_PRE013, httpAPI_PRE016 } from "./api/request";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  CommonOrCommonRetirementFlug,
  FacilityKind,
  FacilityType,
} from "../../assets/data/Constants";
import {
  changeAmountFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import TkAmountInput from "../../components/molecules/TkAmountInput";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import { headList } from "./parts";

/**
 * SCRW080005 確定後掛金の変更登録
 * @return SCRW080005 確定後掛金の変更登録
 */
const SCRW080005 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [applyEvent, setApplyEvent] = useState<any>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>();
  const [showContents, setShowContents] = useState(false);
  const [displayItem, setDisplayItem] = useState<any>();
  const [statusLogList, setStatusListLog] = useState<any>();
  const inputAmt = useRef<any>();
  const [amt, setAmt] = useState(0);
  const [errormsg, setErrorMsg] = useState("");
  const [memo, setMemo] = useState<any>();
  const [memoError, setMemoError] = useState(false);
  const [check, setCheck] = useState<any>();
  const [contractorNo, setContractorNo] = useState<any>();
  const [open, setOpen] = useState(false);
  const [bodyList, setBodyList] = useState<any>([]);

  async function openingScreen() {
    try {
      const res = await httpAPI_PRE013({
        applyId: locationState?.applyId!,
      });
      if (res.resultCd === "I0000") {
        const canEdit = !(
          res?.applyIdList?.[0].latestApplyStatus === "00" ||
          res?.applyIdList?.[0].latestApplyStatus === "16"
        );
        const applyList = res?.applyIdList;
        const showTable = (
          <Box>
            <Box className="tkRightWord">
              <Typography>{"金額単位(円)"}</Typography>
            </Box>
            <Box className="tkItems" data-testid="SCRW080003PageItems">
              <Box className="tkObjArea">
                <Box className="tkTitleLarge">
                  <Typography>{"年度"}</Typography>
                </Box>
                <Box className="tkTitleMiddle">
                  <Typography>{"施設名称"}</Typography>
                </Box>
                <Box className="tkTitleSmall">
                  <Typography>{"種類"}</Typography>
                </Box>
                <Box className="tkTitleSmall">
                  <Typography>{"区分"}</Typography>
                </Box>
                <Box className="tkTitleLarge">
                  <Typography>{"修正前掛金額"}</Typography>
                </Box>
                <Box className="tkTitleLarge">
                  <Typography>{"修正後掛金額"}</Typography>
                </Box>
                <Box className="tkTitleLarge">
                  <Typography>{"請求額"}</Typography>
                </Box>
              </Box>
              {applyList?.map((item, index) =>
                item.facilityList?.map((facility, number) => (
                  <Box key={index + ":" + number} className="tkObjArea">
                    <Box className="tkBodyLarge">
                      <Typography>{(item?.year ?? "") + "年度"}</Typography>
                    </Box>
                    <Box className="tkBodyMiddle">
                      <Typography>
                        {(facility?.facilityNo ?? "") +
                          ":" +
                          (facility?.facilityName ?? "")}
                      </Typography>
                    </Box>
                    <Box className="tkBodySmall">
                      <Typography>
                        {
                          FacilityKind[
                            facility?.facilityKind as keyof typeof FacilityKind
                          ]
                        }
                      </Typography>
                    </Box>
                    <Box className="tkBodySmall">
                      <Typography>
                        {TkGetCode(FacilityType, facility?.facilityKbn)}
                      </Typography>
                    </Box>
                    <Box className="tkBodyLarge">
                      <Typography>
                        {changeAmountFormat(facility?.bCorrectionPremiumAmt!)}
                      </Typography>
                    </Box>
                    <Box className="tkBodyLarge">
                      <Typography>
                        {changeAmountFormat(facility?.premiumAmt!)}
                      </Typography>
                    </Box>
                    <Box className="tkBodyLarge">
                      <Typography>
                        {changeAmountFormat(facility?.amt!)}
                      </Typography>
                    </Box>
                  </Box>
                ))
              )}
            </Box>
          </Box>
        );
        const statusList = res.statusList?.map((item) => [
          { children: item.managerName },
          { children: item.process },
          { children: item.createDate },
          { children: item.processComment },
        ]);
        inputAmt.current = res?.applyAmt!;
        let bodyList = [
          [{ children: res.symbolNo }, { children: res.decisionDate }],
        ];
        setBodyList(bodyList);
        setContractorNo(res?.applyIdList?.[0].contractorNo);
        setAmt(res?.applyAmt!);
        setShowContents(canEdit);
        setDisplayItem(showTable);
        setApplyEvent(res?.applyIdList?.[0].latestApplyStatus);
        setCorpApplyKbn(res?.applyIdList?.[0].corpApplyKbn);
        setStatusListLog(statusList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeAmount = (data: any) => {
    if (data.target.value > 999999999) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999"));
    } else if (!data.target.value) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0043E"));
    } else if (data.target.value < -999999999) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0047E", "-999,999,999"));
    } else {
      inputAmt.current = data.target.value;
      setErrorMsg("");
    }
  };
  const memoSave = (data: any) => {
    if (data.target.type === "input") {
      const originalValue = data.target.value;
      const value = originalValue
        .split("")
        // eslint-disable-next-line no-control-regex
        .filter((char: string) => !/[\x00-\x7F]|[\uff61-\uff9f]/.test(char))
        .join("");

      if (originalValue && value !== originalValue) {
        setMemoError(true);
      } else {
        setMemoError(false);
        setMemo(data.target.value);
      }
    } else {
      setCheck(data.target.value);
    }
  };
  const clickJudgementBtn = (btnName: any) => {
    if (memoError) {
      return;
    }
    switch (btnName) {
      case "受理":
        applyUpdate("2");
        break;
      case "承認":
        setOpen(true);
        break;
      case "課長代理確認":
        applyUpdate("14");
        break;
      case "担当者に差戻し":
        applyUpdate("8");
        break;
      case "上長承認":
        applyUpdate("6");
        break;
      case "郵送":
        applyUpdate("11");
        break;
      default:
        return;
    }
  };
  const clickRegister = async () => {
    if (!!errormsg) {
      return;
    }
    try {
      const res = await httpAPI_PRE016({
        applyId: locationState?.applyId!,
        contractorNo: contractorNo,
        invoiceAmt: inputAmt.current,
        screenId: "SCRW080005",
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const applyUpdate = async (event: any) => {
    try {
      const res = await httpAPI_APP016({
        applyId: locationState?.applyId!,
        applyEvent: event,
        contractorNo: businessState.common?.contractorNo!,
        inquiryCode: !!check ? "1" : undefined,
        screenId: "SCRW080005",
        reason: memo,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const fromDialog = async (data: any) => {
    try {
      const res = await httpAPI_APP016({
        applyId: locationState?.applyId!,
        applyEvent: "3",
        contractorNo: businessState.common?.contractorNo!,
        symbolNo:
          TkGetCode(CommonOrCommonRetirementFlug, data.symbolNumberType) +
          "第" +
          data.symbolNumber +
          "号",
        decisionDate: data.settlementDate,
        transferDueDate: data.scheduledPaymentDate,
        inquiryCode: !!check ? "1" : undefined,
        screenId: "SCRW080005",
        reason: memo,
        dueDate: inputAmt.current > 0 ? data.paymentDeadline : undefined,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="tkSCRW080005" data-testid="SCRW080005PageForTest">
      {showContents && (
        <TkKikoStepper
          applicationFlowType={"TYPE2"}
          businessType="JOB-50"
          corporateApplicationClassification={corpApplyKbn}
          applicationStatus={applyEvent}
        />
      )}
      <TkContractorAndNumberLine
        name="契約者(法人)名"
        no={
          businessState.common?.contractorNo +
          ":" +
          businessState.common?.contractorName
        }
      ></TkContractorAndNumberLine>
      {displayItem}
      <Box className="tkNumberInputArea">
        <Box className="tkNumberInputTitle">
          <Typography>{"請求額合計"}</Typography>
        </Box>
        <Box className="tkNumberInputBody">
          <TkAmountInput
            error={!!errormsg}
            errorMessage={errormsg}
            wantToSetValue={amt}
            disabled={showContents}
            onChange={changeAmount}
            useMinus
          />
        </Box>
      </Box>
      {showContents && (
        <TkMemo
          showCheckBox={true}
          bodyList={statusLogList}
          onChange={memoSave}
        />
      )}
      {isStatusAfterApproval(applyEvent) && (
        <TkTableWithNoLine headList={headList} bodyList={bodyList} />
      )}
      <Box className="tkBtnArea">
        <TkBackButton className="tkBottonMr" />
        {showContents ? (
          <TkViewButtonJudgement
            flowType="TYPE2"
            Status={applyEvent}
            onClick={clickJudgementBtn}
          />
        ) : (
          <TkButton onClick={clickRegister}>{"登録"}</TkButton>
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={fromDialog}
        displayOnlyPaymentDeadline={amt > 0}
        isScheduledPaymentDateVisible={amt < 0}
      />
    </Box>
  );
};

export default SCRW080005;
